import { useEffect, useState } from 'react';
import GeoCombobox from '../../../components/common/GeoCombobox';

/**
 * Union / ward box for one address block: suggests the union parishads of the chosen upazila (Bangla name, English
 * as the hint and searchable), and anything else can be typed — city / pourashava wards ("৫ নং ওয়ার্ড") are not
 * in the list. The stored value is the text in the box.
 *
 * Catalogue: src/data/bd-unions.json (scripts/build-unions.mjs), loaded only when a picker mounts.
 */

let catalogue = null;
const loadCatalogue = () => (catalogue ||= import('../../../data/bd-unions.json').then((m) => m.default.districts));

function useCatalogue() {
    const [data, setData] = useState(null);
    useEffect(() => {
        let alive = true;
        loadCatalogue().then((d) => { if (alive) setData(d); }).catch(() => {});
        return () => { alive = false; };
    }, []);
    return data;
}

export default function UnionPicker({ value, district, upazila, placeholder, onChange }) {
    const data = useCatalogue();
    const options = (data?.[district]?.[upazila] || []).map(([bn, en]) => ({ value: bn, label: bn, hint: en, en }));
    return <GeoCombobox value={value} onChange={onChange} options={options} placeholder={placeholder} clearable />;
}
